var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParchment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1083_9889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 8H6.66669",
    stroke: "#202F3D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 5.33331H6.66669",
    stroke: "#202F3D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 11.3333V3.33333C12.6667 2.97971 12.5262 2.64057 12.2762 2.39052C12.0261 2.14048 11.687 2 11.3334 2H2.66669",
    stroke: "#202F3D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33319 13.9998H13.3332C13.6868 13.9998 14.026 13.8593 14.276 13.6093C14.526 13.3592 14.6665 13.0201 14.6665 12.6665V11.9998C14.6665 11.823 14.5963 11.6534 14.4713 11.5284C14.3462 11.4034 14.1767 11.3332 13.9999 11.3332H7.33319C7.15638 11.3332 6.98681 11.4034 6.86179 11.5284C6.73676 11.6534 6.66652 11.823 6.66652 11.9998V12.6665C6.66652 13.0201 6.52605 13.3592 6.276 13.6093C6.02595 13.8593 5.68681 13.9998 5.33319 13.9998ZM5.33319 13.9998C4.97957 13.9998 4.64043 13.8593 4.39038 13.6093C4.14033 13.3592 3.99986 13.0201 3.99986 12.6665V3.33315C3.99986 2.97953 3.85938 2.64039 3.60933 2.39034C3.35928 2.14029 3.02015 1.99982 2.66652 1.99982C2.3129 1.99982 1.97376 2.14029 1.72372 2.39034C1.47367 2.64039 1.33319 2.97953 1.33319 3.33315V4.66648C1.33319 4.84329 1.40343 5.01286 1.52845 5.13789C1.65348 5.26291 1.82305 5.33315 1.99986 5.33315H3.99986",
    stroke: "#3C5873",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1083_9889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParchment);
export default __webpack_public_path__ + "static/media/parchment.3126366a.svg";
export { ForwardRef as ReactComponent };